import { Collection } from "@type-r/models";
import { CollapsableSection, div, TilesList } from "lqx-react";
import React from "react";
import { AssetChange } from "../api/assetChange";
import { AssetsCollapsableSection } from "../components/asset-section-styles";
import { FormControlLabel, Switch, withStyles } from "@material-ui/core";

export const AssetsSection = <TAssetChange extends AssetChange>(
    { title, assets, assetTile, notExpanded, selected, $active, height, selectAllAssets }
        : {
            title: React.ReactNode,
            assets: TAssetChange[],
            assetTile,
            notExpanded?: boolean,
            selected?: Collection<any>,
            $active?,
            height?: number,
            selectAllAssets?: any
        }) => {
    return (
        <AssetsCollapsableSection>
            <CollapsableSection qa-id="AssetsSection" title={title} notExpanded={notExpanded}>
                <StyledFormControlLabel
                    control={
                        <Switch
                            defaultChecked={selectAllAssets.value}
                            onChange={(e, c) => {
                                selectAllAssets.set(c);
                                
                                if (c) {
                                    selected.add(assets);
                                } else {
                                    selected.reset();
                                }
                            }}
                            color="primary"
                        />
                    }
                    label={"Select All"}
                    labelPlacement="start"
                />
                <TilesListContainer>
                    <TilesList
                        height={height || 150}
                        items={assets}
                        itemSize={70}
                        selected={undefined}
                        renderer={assetTile($active, selected, selectAllAssets)} />
                </TilesListContainer>
            </CollapsableSection>
        </AssetsCollapsableSection>
    );
};

const TilesListContainer = div({
    marginTop: '15px'
})

const StyledFormControlLabel = withStyles({
    label: {
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: 'grey'
    },
    labelPlacementStart: {
        margin: '0 !important',
        width: '130px'
    }
})(FormControlLabel)